import { ReactNode } from 'react';
import { Header } from './Header';
import styles from './Layout.module.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className={styles.wrapper}>
      <Header />
      <div className={styles.container}>
        {/* Left Panel - Desktop/Tablet Only */}
        <aside className={styles.leftPanel} aria-label="Information panel">
          <div className={styles.section}>
            <h2>The Concierge Economy</h2>
            <p className={styles.quote}>
              "Whether your customer's budget is prosecco or champagne, everyone wants that concierge experience"
            </p>
            <p>
              No matter the channel, the product, or the price, every customer expects an exceptional experience. Every interaction, regardless of budget, deserves the premium treatment once reserved for high-value customers. Amazon Connect delivers this at scale.
            </p>
          </div>
          
          <div className={styles.section}>
            <h2>Featured Innovations</h2>
            <p>We're launching breakthrough AI capabilities that transform customer service:</p>
            <ul aria-label="Featured innovations list">
              <li>Agentic AI that reasons, plans, and acts autonomously</li>
              <li>Built-in AI from the ground up, not bolted on</li>
              <li>Competitive pay-as-you-go pricing without token penalties</li>
              <li>Testing and simulation tools for confidence</li>
            </ul>
          </div>
          
          <div className={styles.section}>
            <h2>How It Works</h2>
            <div className={styles.architectureDiagram} role="img" aria-label="Architecture flow: Browser to Amazon Connect to speech-to-speech to Agentic AI">
              <p><strong>Browser → Amazon Connect → speech-to-speech → Agentic AI</strong></p>
              <p style={{ marginTop: '12px', fontSize: '12px' }}>
                Natural voice conversations paired with autonomous agents that handle complex scenarios end-to-end.
              </p>
            </div>
          </div>
          
          <div className={styles.section}>
            <h2>Why Amazon Connect</h2>
            <ul aria-label="Amazon Connect benefits">
              <li>Built-in AI from the ground up</li>
              <li>Competitive pay-as-you-go pricing</li>
              <li>Testing and simulation tools for confidence</li>
              <li>Trusted at Amazon scale</li>
              <li>AI amplifies humans, not replaces them</li>
            </ul>
          </div>
        </aside>
        
        {/* Right Panel - Main Content */}
        <main className={styles.rightPanel} role="main" aria-label="Main content">
          {children}
        </main>
      </div>
    </div>
  );
}
